<div class="checkbox" [style.margin-top.rem]="1">
    <input [id]="'checkbox-terms'" type="checkbox" [formControl]="termsAcceptControl" [formControlDataTest]="'termsAccept'" />
    <label [for]="'checkbox-terms'" class="text-light-shadow-v2 inform-label text-oneline pe-2 pe-md-8 w-100" aria-hidden="true">
        <span class="text-wrap text-line-2 text-light-shadow-v2" [style.font-weight]="600">
            {{ 'v3-manager-settings-content-byoc-upload-terms' | translate }}
        </span>
        <span class="icon" [inlineSVG]="'assets/icons.svg#checkbox'"></span>
    </label>
</div>
